import { AreaType } from '@/types/booliApi';

export const AREA_SWEDEN = [77104];
export const AREA_COUNTY_SWEDEN = [
  145, 322, 645, 581, 160, 456, 153, 381, 783, 802, 64, 2, 26, 118, 390, 588, 250, 315, 23, 318, 253,
];
export const SEARCH_TYPES = [
  AreaType.Country,
  AreaType.County,
  AreaType.Municipality,
  AreaType.PopulatedArea,
  AreaType.undefined,
  AreaType.Suburb,
  AreaType.Locality,
  AreaType.SuburbAndLocality,
  AreaType.UserDefined,
  AreaType.IndexArea,
];

export const CSRF_TOKEN_NAME = 'csrftoken_v2';
